export default {
    locale: 'cs',
    global: {
        appName: 'Trisbee Pokladna',
        ok: 'Ok',
        offline: 'offline',
        back: 'Zpět',
        delete: 'Smazat',
        save: 'Uložit',
        logout: 'Odhlásit',
        print: 'Tisk',
        yes: 'Ano',
        no: 'Ne',
        reload: 'Obnovit'
    },
    login: {
        changeOrganization: 'Změnit organizaci',
        language: 'Změnit jazyk',
        login: 'Email',
        password: 'Heslo',
        loginBtn: 'Přihlásit'
    },
    chooseBar: {
        noBranch: {
            title: 'Žádný bar',
            text: 'Je třeba založit bar, přidat mu pokladnu a naplněnou nabídku.'
        },
        selectBranch: {
            title: 'Vybrat bar'
        }
    },
    deviceName: {
        title: 'Pojmenovat zařízení',
        deviceName: 'Název zařízení'
    },
    chooseOffer: {
        title: 'Vybrat nabídku'
    },
    browser: {
        line1: 'Bohužel Váš prohlížeč je zastaralý nebo nepodporovaný.',
        line2: 'Stáhněte si, prosím, nejnovější verzi jednoho z následujících:'
    },
    openReport: {
        title: 'Otevření dne',
        text1: 'Pro bar',
        text2: 'není otevřen barový report.',
        text3: 'Chcete barový report otevřít nyní?',
        open: 'Otevřít barový report',
        alreadyOpen: 'Report je již otevřen.'
    },
    homepage: {
        controls: {
            table: 'Účet',
            issue: 'Výdej',
            quickSale: 'Rychlý prodej',
            toBill: 'Zaseknout',
            pay: 'Platit'
        },
        receipt: {
            sum: 'Celkem',
            table: 'účet'
        }
    },
    tables: {
        newTable: 'Nový účet',
        toCashbox: 'Do pokladny',
        layout: {
            select: 'Výběr rozvržení stolů',
            noLayout: 'Bez rozvržení'
        },
        newPopup: {
            title: 'Název účtu',
            nameNotUnique: 'Název není unikátní'
        }
    },
    divideTable: {
        payAll: 'Zaplatit vše',
        removeAll: 'Smazat vše',
        toBill: 'Na účet',
        pay: 'Platit'
    },
    payment: {
        sale: 'Sleva',
        paid: 'Placeno',
        afterSale: 'Po slevě',
        toPayment: 'K platbě',
        return: 'Vrátit',
        sell: 'Prodat'
    },
    menu: {
        waitingOrders: 'Počet neodeslaných offline účtenek:',
        toTables: 'Na stoly',
        toCashbox: 'Do pokladny',
        message: {
            reportClosed1: 'Report je již uzavřený, posledních',
            reportClosed2: 'prodejů je mimo report.',
            deviceOffline: 'Zařízení je offline.',
            unableCloseReport: 'Není možné uzavřít report.',
            notSentBills: 'Počet neodeslaných účtenek:',
            billSendLater: 'Tyto účtenky se odešlou po dalším přihlášení.',
            tablesNotPayed: 'Nejsou zaplacené všechny účty'
        },
        issuedReceipts: 'Vydané doklady',
        dailyReport: 'Denní report',
        credits: 'Zatínáček',
        favourites: 'Oblíbené položky',
        settings: 'Nastavení',
        lock: 'Zamknout / změnit uživatele',
        offlineMode: '(Offline režim)',
        shifts: 'Směny',
        payouts: 'Odvody',
        cashboxState: 'Stavy pokladen'
    },
    issuedReceipts: {
        title: 'Vydané účtenky',
        time: 'Čas',
        table: 'Účet',
        items: 'Položky',
        sum: 'částka',
        cashbox: 'Pokladna',
        storno: 'Storno'
    },
    credits: {
        title: 'Zatínáček',
        paySelected: 'Platit označené',
        payAll: 'Platit vše',
        date: 'Zaseknuto',
        table: 'Účet',
        entered: 'Zadal',
        debt: 'Dluh',
        pay: 'Platit',
        print: 'Tisk'
    },
    favourites: {
        title: 'Oblíbené položky',
        addShortcut: 'Přidat volbu',
        frequentlyUsed: 'Často využívané položky'
    },
    settings: {
        title: 'Nastavení',
        lockTime: 'Čas uzamknutí',
        tabs: {
            sell: 'Prodej',
            system: 'Systém',
            print: 'Tisk'
        },
        disable: 'Zakázat',
        selectOffer: 'Výběr nabídky',
        on: 'Zapnuto',
        off: 'Vypnuto',
        allow: 'Povolit',
        deny: 'Zakázat',
        printBill: {
            title: 'Tisk účtenky při prodeji',
            subtitle: 'Automaticky vytisknout účtenku při zaplacení'
        },
        localstorage: {
            send: 'Odeslat',
            title: 'Odeslat systémové informace',
            subtitle: 'Použijte pouze na základě instrukcí.'
        },
        deviceName: {
            title: 'Název zařízení',
            change: 'Změnit',
            keyboardName: 'Název zařízení (alespoň 3 znaky)',
            error: 'Zadejte alespoň 3 znaky'
        },
        print: {
            bt: 'Zadejte název spárovaného bluetooth zařízení',
            ipOrHost: 'Zadejte prosím IP nebo hostname, případně port (výchozí port 9100) (např. 192.168.2.4 nebo 10.0.2.3:9100 nebo posprinter:9100)',
            device: 'Zařízení (např. /dev/ttyS0 nebo COM1)',
            lineLength: 'Délka řádku - počet znaků',
            test: 'Test ESC/POS'
        },
        offer: {
            title: 'Nabídka',
            select: 'Nahrát nabídku'
        },
        fullscreen: {
            title: 'Zobrazit okno na celou obrazovku'
        },
        homepage: {
            title: 'Hlavní obrazovka',
            subtitle: 'Odkud se začíná zapisovat objednávka',
            goods: 'Zboží',
            tables: 'Účty'
        },
        kitchenPrint: {
            title: 'Tisknout objednávku po přidání na účet nebo prodeji',
            subtitle: 'Tiskne se jen zboží z nabídky označené jako "objednávka"',
            test: 'Test ESC/POS'
        },
        kitchenItemStyle: {
            title: 'Tisknout zboží v objednávce po jednom',
            subtitle: 'Zboží bude na objedávce rozepsané pod sebou podle množství'
        },
        pin: {
            title: 'Přihášení PINem',
            subtitle: 'Do 24 hodin od posledního odhlášení se lze přihlásit PINem'
        },
        cursor: {
            title: 'Skrýt kurzor',
            subtitle: 'Pro použití na dotykových obrazovkách'
        },
        paymentInput: {
            title: 'Při platbě označit',
            sale: 'Sleva %',
            saleCurrency: 'Sleva Kč',
            paid: 'Placeno'
        },
        autoLock: {
            title: 'Automatické zamykání obrazovky'
        },
        printType: {
            title: 'Výchozí způsob tisku',
            kitchenTitle: 'Způsob tisku objednávky',
            subtitle: 'Pro tisk účtenek a přehledů',
            change: 'Změnit',
            charOnLine: 'znaků na řádek',

            off: 'Vypnuto',
            default: 'Výchozí tiskárna',
            defaultSilent:  'Výchozí tiskárna (bez potvrzování tiskovým dialogem)',
            escposUsb: 'ESC/POS USB',
            escposSerial: 'ESC/POS Sériový port',
            escposNet: 'ESC/POS Síťová tiskárna',
            escposBt: 'ESC/POS Bluetooth tiskárna'
        },
        printTypeOrder: {
            title: 'Způsob tisku objednávky',
            subtitle: 'Tiskne se jen zboží z nabídky označené jako "objednávka"',
            charOnLine: 'znaků na řádek',
            change: 'Změnit'
        },
        silentPrint: {
            title: 'Silent print',
            subtitle: 'Tisk účtenky na pozadí (bez okna výběru tiskárny)'
        },
        language: {
            title: 'Jazyk'
        }
    },
    pin: {
        changeOrg: 'Změnit organizaci',
        pin: 'PIN',
        passwordLogin: 'Přihlášení heslem'
    },
    domain: {
        orgCode: 'Kód organizace',
        codeNotExists: 'Kód organizace neexistuje.',
        continue: 'Pokračovat',
        serverUnavailable: 'Server je momentálně nedostupný, zkuste to prosím za chvíli.',
        migrationTroubleshoot: 'Problémy s migrací'
    },
    migrationTroubleShooter: {
        migrationId: 'Id migrace',
        migrationIdError: 'Nastala chyba, zadali jste správně id migrace?'
    },
    moneyCount: {
        fillPcs: 'Vyplnit kusy',
        sum: 'Celkem',
        count: 'Počítat',
        dailyReport: 'Denní report > Stavy pokladen',
        cashbox: 'Kasa',
        start: 'Počátek',
        end: 'Konec'
    },
    timepicker: {
        am: 'Dopoledne',
        pm: 'Odpoledne'
    },
    shifts: {
        barmanSelect: 'Výběr barmana',
        payFromCashbox: 'Vyplatit z pokladny',
        dailyReport: 'Denní report > Směny',
        add: 'Přidat',
        barman: 'Barman',
        rate: 'Sazba',
        from: 'od',
        to: 'do',
        salary: 'Výplata',
        endShift: 'Ukončit směnu',
        paid: 'Vyplaceno'
    },
    transactions: {
        new: 'Nová transakce',
        chooseCashbox: 'Vybrat pokladnu',
        income: 'Příjem',
        outcome: 'Výdej',
        transfer: 'Převod',
        send: 'Odeslat',
        dailyReport: 'Denní report > Odvody',
        add: 'Přidat',
        time: 'Čas',
        paied: 'Odvedeno/Zaplaceno',
        amount: 'Částka',
        created: 'Vytvořil',
        name: 'Název',
        fromCashbox: 'Z pokladny',
        toCashbox: 'Do pokladny',
        cashbox: 'Pokladny',
        idNumber: 'Číslo dokladu',
        note: 'Poznámka'
    },
    print: {
        order: 'Objednávka',
        bar: 'Bar',
        bill: 'Účet',
        debtList: 'Zatínáček',
        storno: 'STORNO',
        discount: 'Sleva',
        idNumber: 'IČO',
        vatId: 'DIČ',
        vat: 'DPH',
        reportNotOpen: 'Není otevřen barový report nebo zatím nebylo nic prodáno.',
        noVat: 'Neplátce DPH',
        sale: 'PRODEJ',
        turnover: 'OBRAT POKLADEN',
        difference: 'ROZDÍL',
        sales: 'TRŽBA (včetně účtů)',
        documentId: 'Doklad č.',
        orderNum: 'Číslo objednávky',
        payInCash: 'Platba v hotovosti',
        payByCard: 'Platba platební kartou',
        normalMode: 'Běžný režim',
        offlineMode: 'Offline režim',
        branch: 'Pobočka',
        onlineBill: 'Online účtenka',
        thankYou: 'DĚKUJEME A PŘIJĎTE ZAS',
        soldAndPrint: 'prodalo a vytisklo Trisbee.com',
        notReceipt: 'Toto není účtenka. Vyžádejte platnou účtenku od obsluhy prosím.',
        tableToDate: 'Stav účtu k'
    },
    closeReport: {
        closeDay: 'Zavřít den',
        reportOpen: 'Barový report je otevřen, chcete ho zavřít nyní?',
        cantClose: 'Barový report není možné zavřít z důvodu:',
        tryAgain: 'Zkusit znovu zavřít report a odhlásit',
        closeAndLogout: 'Zavřít report a odhlásit',
        onlylogout: 'Jen odhlásit',
        continue: 'Pokračovat',
        closeReport: 'Zavřít report'
    }
}



// WEBPACK FOOTER //
// ./src/common/intl/messages/cs.js